import { lazyLoad } from 'utils/loadable';

export const AddNewReportPage = lazyLoad(
  () => import('./index'),
  module => module.AddNewReportPage,
);
